import InitialLoadingScreen from './InitialLoadingScreen';

export default InitialLoadingScreen;
